(function () {
  function applyDiscount(root) {
    var input = root.querySelector('[data-fe-cart-discount-input]');
    var status = root.querySelector('[data-fe-cart-discount-status]');
    var btn = root.querySelector('[data-fe-cart-discount-apply]');
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      if (status) {
        status.hidden = false;
        status.textContent = 'Enter a discount code.';
      }
      return;
    }

    if (btn) btn.disabled = true;
    if (status) {
      status.hidden = false;
      status.textContent = 'Applying…';
    }

    var redirect = window.location.pathname + window.location.search;
    window.location.href =
      '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
  }

  function bindDiscount(root) {
    if (!root || root.getAttribute('data-fe-cart-discount-bound') === 'true') return;
    root.setAttribute('data-fe-cart-discount-bound', 'true');

    var btn = root.querySelector('[data-fe-cart-discount-apply]');
    var input = root.querySelector('[data-fe-cart-discount-input]');

    if (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        applyDiscount(root);
      });
    }

    if (input) {
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyDiscount(root);
        }
      });
    }
  }

  function parseJsonAttr(el, name) {
    try {
      return JSON.parse(el.getAttribute(name) || '[]');
    } catch (e) {
      return [];
    }
  }

  function findVariant(variants, options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if ((v.options[j] || '') !== options[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function refreshCartDrawer() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') {
      cartItems.getCart();
      return;
    }
    window.location.reload();
  }

  function swapVariant(wrapper, nextVariantId) {
    var lineKey = wrapper.getAttribute('data-line-key');
    var qty = parseInt(wrapper.getAttribute('data-quantity') || '1', 10) || 1;
    if (!lineKey || !nextVariantId) return;

    wrapper.classList.add('is-loading');
    var selects = wrapper.querySelectorAll('[data-fe-cart-option]');
    selects.forEach(function (s) {
      s.disabled = true;
    });

    var properties = {};
    var itemEl = wrapper.closest('[data-item]');
    if (itemEl) {
      itemEl.querySelectorAll('.cart__item__property').forEach(function (p) {
        var strong = p.querySelector('strong');
        var span = p.querySelector('span');
        if (strong && span) {
          var name = strong.textContent.replace(/:\s*$/, '').trim();
          if (name && name.charAt(0) !== '_') {
            properties[name] = span.textContent.trim();
          }
        }
      });
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        var payload = { items: [{ id: nextVariantId, quantity: qty }] };
        if (Object.keys(properties).length) {
          payload.items[0].properties = properties;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Variant unavailable');
        }
        refreshCartDrawer();
      })
      .catch(function (err) {
        console.error(err);
        alert(err.message || 'Could not update size. Please try again.');
        selects.forEach(function (s) {
          s.disabled = false;
        });
        wrapper.classList.remove('is-loading');
        refreshCartDrawer();
      });
  }

  function onOptionChange(event) {
    var select = event.target;
    if (!select || !select.matches('[data-fe-cart-option]')) return;

    var wrapper = select.closest('[data-fe-cart-variant-swap]');
    if (!wrapper || wrapper.classList.contains('is-loading')) return;

    var variants = parseJsonAttr(wrapper, 'data-variants');
    var current = parseJsonAttr(wrapper, 'data-current-options').slice();
    var index = parseInt(select.getAttribute('data-option-index'), 10);
    if (isNaN(index)) return;

    current[index] = select.value;
    var match = findVariant(variants, current);

    if (!match || !match.available) {
      match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[index] === select.value && v.available) {
          match = v;
          break;
        }
      }
    }

    if (!match) {
      alert('That option combination is not available.');
      var prev = parseJsonAttr(wrapper, 'data-current-options');
      if (prev[index] != null) select.value = prev[index];
      return;
    }

    var prevOptions = parseJsonAttr(wrapper, 'data-current-options');
    var prevMatch = findVariant(variants, prevOptions);
    if (prevMatch && prevMatch.id === match.id) return;

    wrapper.setAttribute('data-current-options', JSON.stringify(match.options));
    swapVariant(wrapper, match.id);
  }

  function bindVariantSelects() {
    document.querySelectorAll('[data-fe-cart-variant-swap]').forEach(function (wrapper) {
      if (wrapper.getAttribute('data-fe-bound') === 'true') return;
      wrapper.setAttribute('data-fe-bound', 'true');
      wrapper.addEventListener('change', onOptionChange);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-fe-cart-discount]').forEach(bindDiscount);
    bindVariantSelects();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('theme:cart:change', initAll);
  document.addEventListener('theme:cart-drawer:open', initAll);

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    var timer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(initAll, 50);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  });
})();
